import { Component, OnInit, Input, Output, ViewChild, TemplateRef } from '@angular/core';
import _ from 'lodash';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ViewVoucherService } from './view-voucher.service';
import { TranslateService } from '@root/shared/service/translate.service';
// import { CREDENTIAL_TYPE } from '@root/config';
import { Translate } from '@root/util/decorator';
import { ModalService } from '@root/router/index/modal.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

interface IPicture {
  id?: number;
  url: string;
  large_url?: string;
  checked?: boolean;
}

interface Image {
  filename?: string;
  original_url?: string;
  small_url?: string;
  large_url?: string;
}

enum AuditStatus {
  Approve = 2,
  Reject = -2,
  Pending = 1,
  NoAuditRequired = -1, // 无需审核
}

@Component({
  selector: 'host-view-voucher',
  templateUrl: './view-voucher.component.html',
  styleUrls: ['./view-voucher.component.scss'],
})
export class ViewVoucherComponent implements OnInit {
  get selectedGuestName() {
    if (this.selectedGuest === -1) {
      return '不关联';
    } else {
      const guest = this.relatedGuestList.find((g) => g.id === this.selectedGuest);
      return guest && guest.name;
    }
  }

  constructor(
    private modalService: NzModalService,
    private modalRef: NzModalRef,
    private voucherService: ViewVoucherService,
    private translateService: TranslateService,
    private messageService: NzMessageService,
    private globalModal: ModalService,
    private fb: UntypedFormBuilder
  ) {}

  readonly AuditStatus: typeof AuditStatus = AuditStatus;
  @Input() auditStatus: AuditStatus;

  @Input() pictureList: Array<IPicture> = [];
  @Input() checkedIndex = 0;
  @Input() type: 'voucher' | 'credentials' = 'voucher';
  @Input() code: string = null; // 入住单号
  @Input() orderCode: string = null; // 订单号
  @ViewChild('rejectTpl') rejectTpl: TemplateRef<any>;
  checkedPic;
  selectedGuest;
  relatedGuestList = [];

  maxSize = 10; // 最多上传10张照片
  listOfUploadImage: Array<Image> = [];

  rejectForm: UntypedFormGroup = this.fb.group({
    reason: null,
  });

  clientDropdownVisible = false;

  @Translate('component.upload.image_format_restrictions') extLimitWarning;
  @Translate('component.upload.image_number_reached_limit') amountLimitWarning;
  @Translate('warning.upload_image_too_large') sizeLimitWarning;

  beforeUpload = (file) => {
    const size = file.size;
    const type = file.type;

    if (['image/jpeg', 'image/jpg', 'image/png'].indexOf(type) === -1) {
      // this.messageService.info('只允许上传jpg和png格式的图片');
      this.messageService.info(this.extLimitWarning);
      return false;
    }

    if (this.listOfUploadImage.length >= this.maxSize) {
      // this.messageService.info('上传图片数量已达上限');
      this.messageService.info(this.amountLimitWarning);
      return false;
    }

    if (size > 10 * 1024 * 1024) {
      // this.messageService.info('图片过大，请选择小于10M的图片上传！');
      this.messageService.info(this.sizeLimitWarning);
      return false;
    }

    return true;
  };

  ngOnInit() {
    console.log('audit status: ', this.auditStatus);

    if (this.type === 'voucher') {
      this.formatPictureList(this.pictureList);
    } else {
      this.getCredentialsList();
      this.fetchRelatedGuestList();
    }
  }

  formatPictureList(data) {
    for (let i = 0; i < data.length; i++) {
      _.assign(data[i], {
        checked: i === this.checkedIndex ? true : false,
      });
    }
    this.checkedPic = this.pictureList[this.checkedIndex];
  }

  getCredentialsList() {
    this.voucherService
      .getGuideAuditingImages({
        reservation_code: this.code,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.pictureList = this.formatCredentials(_.get(res, 'data'));
          this.formatPictureList(this.pictureList);

          this.selectedGuest = _.get(this.pictureList[0], 'client_id');
          // if (!_.isNil(index)) {
          //   if (index === -1) {
          //     this.selectedGuest = null;
          //   }
          // } else {
          //   this.selectedGuest = _.get(this.pictureList[0], 'client_id');
          // }
        }
      });
  }

  formatCredentials(data) {
    const list = [];
    let i = 0;
    _.forEach(data, (pic) => {
      list.push({
        id: pic.id,
        url: _.get(pic, 'image.small_url'),
        large_url: _.get(pic, 'image.large_url'),
        client_id: _.get(pic, 'client_id'),
        index: i++,
        info: _.get(pic, 'image_info'),
      });
    });
    return list;
  }

  private fetchRelatedGuestList() {
    const params = {
      page: 1,
      page_size: 99999,
      reservation_order_code: this.orderCode,
    };
    this.voucherService.getRelatedGuestList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.relatedGuestList = this.format(_.get(res, 'data.list'));
      }
    });
  }

  format(data) {
    // _.forEach(data, (guest) => {
    //   _.assign(guest, {
    //     idType: this.getIdType(_.get(guest, 'id_type')),
    //   });
    // });
    return data;
  }

  // getIdType(value) {
  //   const item = _.find(CREDENTIAL_TYPE, { value });
  //   return item ? this.translateService.syncGet(item.i18nName) : null;
  // }

  onClickPicture(pic, index) {
    this.checkedPic = pic;
    console.log('this.chpic: ', this.checkedPic);
    this.checkedIndex = index;
    _.forEach(this.pictureList, (item) => {
      item.checked = false;
    });
    pic.checked = true;
    this.selectedGuest = _.get(pic, 'client_id');
  }

  onClickDeletePicture(e, picture) {
    e.stopPropagation();
    const warningText = this.translateService.syncGet('warning.confirm_to_delete');
    this.modalService.warning({
      nzTitle: warningText,
      nzContent: null,
      nzOkText: this.translateService.syncGet('word.confirm'),
      nzCancelText: this.translateService.syncGet('word.cancel'),
      nzOnOk: () => this.queryDelete(picture),
    });
  }

  queryDelete(picture) {
    const params = {
      reservation_code: this.code,
      id: picture.id,
    };
    this.voucherService.deleteGuideImage(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.getCredentialsList();
      }
    });
  }

  private hideClientDropdown() {
    this.clientDropdownVisible = false;
  }

  onClickDropdownMenuItem(value: number) {
    this.hideClientDropdown();

    if (value === -2) {
      return this.displayCreateGuestModal();
    }

    this.selectedGuest = value;

    const params = {
      client_id: value,
      guide_auditing_image_id: _.get(this.checkedPic, 'id'),
    };
    this.voucherService.relateClient(params).subscribe((res) => {
      if (res.error_code === 0) {
        // 关联成功
        let successText;
        if (value !== -1) {
          successText = this.translateService.syncGet('success.credentials_related_to_guest');
        } else {
          successText = '已解除关联';
        }
        this.messageService.success(successText);
        this.getCredentialsList();
      }
    });
  }

  updateAuditStatus(status: AuditStatus, reason?: string) {
    const params = {
      reservation_code: this.code,
      status: status,
      reason,
    };
    this.voucherService.ediGuideAuditingStatus(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.modalRef.triggerOk();
        this.modalRef.close();
      }
    });
  }

  addPhotos(result) {
    console.log(result);
    const file = result.file;
    if (file.status === 'done') {
      const urls = _.get(file, 'response.data.file');
      this.voucherService
        .addGuideImage({
          reservation_code: this.code,
          image: JSON.stringify(urls),
        })
        .subscribe((res) => {
          if (res.error_code === 0) {
            setTimeout(() => {
              this.getCredentialsList();
              this.fetchRelatedGuestList();
            }, 1000);
          }
        });
    }
  }

  getGender(gender) {
    return gender === 1
      ? this.translateService.syncGet('word.male')
      : gender === 2
      ? this.translateService.syncGet('word.female')
      : null;
  }

  onClickReject() {
    this.displayRejectModal();
  }

  private relateGuestToReservation(client_id, reservation_code) {
    return new Promise((res, rej) => {
      this.voucherService.relateClientToReservation({ client_id, reservation_code }).subscribe((rst) => {
        res(null);
      });
    });
  }

  private displayCreateGuestModal() {
    const modal = this.globalModal.displayCreateGuestModal();
    modal.afterClose.subscribe((rst) => {
      if (rst && rst.data.id) {
        this.relateGuestToReservation(rst.data.id, this.code).then((rst) => {
          this.fetchRelatedGuestList();
        });
      }
    });
  }

  private displayRejectModal() {
    this.modalService.create({
      // nzTitle: '确认不通过？',
      nzTitle: this.translateService.syncGet('reservation.info.audit.reject_modal.title'),
      nzContent: this.rejectTpl,
      nzWidth: 400,
      nzOnOk: () => {
        console.log('what');
        const reason = this.rejectForm.get('reason').value;
        this.updateAuditStatus(AuditStatus.Reject, reason);
      },
    });
  }
}
